interface ImportIconProps {
  size?: number;
  className?: string;
}

const ImportIcon: React.FC<ImportIconProps> = ({ size = 24, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <path d="M4 14v3.5A2.5 2.5 0 0 0 6.5 20h11a2.5 2.5 0 0 0 2.5-2.5V14" />
      <path d="M12 3.5v10.5" />
      <path d="M7.75 9.75 12 14l4.25-4.25" />
    </svg>
  );
};

export default ImportIcon;
